import { Box, List, useTheme } from "@mui/material"
import SimpleBar from "simplebar-react"
import { SearchListItem } from "./SearchListItem"
import { NoSearchResult } from "./NoSearchResult"
import { FeatureSkeletonListItem } from "../features"
import { SKELETON_COUNT, SKELETON_INDEX_TO_REF } from "constant"
import { useVenue } from "providers/venue"

export const SearchResult = ({
  startAdornment,
  popupType,
  noSearchResult = <NoSearchResult />,
  renderSearchItem: RenderSearchItem = SearchListItem,
  renderLoadingItem: RenderLoadingItem = FeatureSkeletonListItem,
  items,
  hasNextPage,
  onSelect,
  endScrollRef,
}) => {
  const theme = useTheme()
  const { isMultiVenueProject } = useVenue()
  const styles = theme.components[`VuiSearchResult`]?.styleOverrides || {}
  return (
    <Box
      className="VuiSearchResult-root"
      sx={[styles.root, styles[`root${popupType}`]]}
    >
      {items.length > 0 ? (
        <SimpleBar style={{ width: "100%", height: "100%" }}>
          {startAdornment}
          <List sx={styles.list}>
            {items.map((item, index) => (
              // TODO:: Render collapse list item when hasMultipleLocations (has same name.en)
              <RenderSearchItem
                sx={styles.listItem}
                key={index}
                data={item}
                isNewShop={item?.isNewShop}
                isComingSoon={item?.isComingSoon}
                onClick={() => onSelect(item)}
                endAdornmentSlotClasses={{
                  text: item.venueRef,
                }}
                endAdornmentSlots={{
                  text: item?.properties?.level_name,
                  media: isMultiVenueProject && item.venueLogo,
                }}
              />
            ))}
            {hasNextPage &&
              Array.from({ length: SKELETON_COUNT }).map((_, index) => (
                <RenderLoadingItem
                  ref={index === SKELETON_INDEX_TO_REF ? endScrollRef : null}
                  key={`loading-${index}`}
                  sx={styles.listItem}
                />
              ))}
            <Box ref={endScrollRef} />
          </List>
        </SimpleBar>
      ) : (
        noSearchResult
      )}
    </Box>
  )
}
